import { IsOptional } from 'class-validator';

/**
 * Simplified DTO for bulk updating a Client Information Record with all sections.
 * Uses plain objects instead of nested DTOs to avoid decorator complexity.
 * Validation will be handled at the service layer.
 */


/**
 * Main DTO for bulk updating a Client Information Record with all sections.
 * Uses plain objects for simplicity and flexibility.
 */
export class BulkUpdateClientInformationRecordRequestDto {
    /**
     * Basic information updates (optional)
     */
    @IsOptional()
    basicInformation?: any;

    /**
     * Organization operations
     * Structure: { associate?: string[], create?: any[], update?: {id: string, data: any}[], disassociate?: string[] }
     */
    @IsOptional()
    organizations?: any;

    /**
     * Product operations
     * Structure: { associate?: string[], create?: any[], update?: {id: string, data: any}[], disassociate?: string[] }
     */
    @IsOptional()
    products?: any;

    /**
     * Contact operations
     * Structure: { create?: any[], associate?: any[], update?: any[], delete?: string[] }
     */
    @IsOptional()
    contacts?: any;

    /**
     * Process configurations (array to support multiple configs of same type)
     * Each item: { id?: string, data: any }
     */
    @IsOptional()
    recallProcessConfigs?: any[];

    @IsOptional()
    dispositionProcessConfigs?: any[];

    @IsOptional()
    complaintsProcessConfigs?: any[];

    @IsOptional()
    pvProcessConfigs?: any[];

    @IsOptional()
    tempExcursionPostReleaseConfigs?: any[];

    @IsOptional()
    returnsProcessConfigs?: any[];

    @IsOptional()
    destructionProcessConfigs?: any[];

    @IsOptional()
    hcLotReleaseConfigs?: any[];

    @IsOptional()
    medicalDeviceReleaseConfigs?: any[];

    @IsOptional()
    mandatoryProblemReportingConfigs?: any[];

    @IsOptional()
    shippingProcessConfigs?: any[];

    /**
     * Warehouse details operations
     * Structure: { createOrUpdate?: {id?: string, data: any}[], delete?: string[] }
     */
    @IsOptional()
    warehouseDetails?: any;

    /**
     * Document approval operations
     * Structure: { createOrUpdate?: {id?: string, data: any}[], delete?: string[] }
     */
    @IsOptional()
    documentApprovals?: any;

    /**
     * Version upgrade information for tracking changes
     */
    @IsOptional()
    versionUpgrade?: {
        upgradeMajor: boolean;
        targetVersion?: { major: number; minor: number };
    };

    /**
     * IDs of process configs to delete
     */
    @IsOptional()
    deleteProcessConfigs?: {
        recallProcess?: string[];
        dispositionProcess?: string[];
        complaintsProcess?: string[];
        pvProcess?: string[];
        tempExcursionPostRelease?: string[];
        returnsProcess?: string[];
        destructionProcess?: string[];
        hcLotRelease?: string[];
        medicalDeviceRelease?: string[];
        mandatoryProblemReporting?: string[];
        shippingProcess?: string[];
    };
}
